<section class="policy-list">
    <div class="policy-groups">
        <app-policy-list-group 
            *ngFor="let group of policy_groups" 
            [group]="group"
        >
        </app-policy-list-group>
    </div>

    <!-- <div class="layouts">
        <span [class]="layout === 'columns' ? 'selected' : ''" (click)="layout='columns'">Columns</span> |
        <span [class]="layout === 'inline' ? 'selected' : ''" (click)="layout='inline'">Inline</span>
    </div> -->

    <div class="policies" [class]="layout">
        <app-policy-list-item
            *ngFor="let policy of policies"
            [policy]="policy"
            [layout]="layout"
            (onClick)="select_policy($event)"
        >
        </app-policy-list-item >
    </div>
</section>
